module.exports = "/_next/static/images/dz-0ffabba444bc348f5bb9adf03ffe37c8.svg";